import cx from "classnames";
import _ from "lodash";
import React from "react";
import styles from "./Pips.scss";

export class Pips extends React.PureComponent {
  render() {
    const { stepCount, activeIndex, onClickPip } = this.props;

    return (
      <div className={styles.Pips}>
        {_.times(stepCount, (i) => (
          <span className={cx(styles.pip, activeIndex === i && styles.active)} onClick={() => onClickPip(i)} key={i} />
        ))}
      </div>
    );
  }
}
